module.exports = __webpack_public_path__ + "img/founder4.f72edf83.jpg";